import { createRedesignEntry } from "../redesign-page-entry";

/**
 * Lazy entry for the redesign-v1 promo-materials page — shell is eager; only the page body is code-split.
 */
export default createRedesignEntry(() => import("./promo-page"), {
  testId: "rd-promo-loading",
  shell: { activeNav: "materials" },
});
